export const filterObject = (
  obj: Record<string, any>,
  callback: (key: string, value: any) => boolean,
) => {
  return Object.fromEntries(Object.entries(obj).filter(([key, value]) => callback(key, value)));
};
